module.exports = __webpack_public_path__ + "img/image24.1b92b5ca.png";